<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Detalle tarimas de traslados y devoluciones</h5>
        <!-------------------- START - Controles arriba de tabla-------------------->
        <div class="controls-above-table">
          <div class="row">
            <div class="col-sm-12">
              <div class="form-inline justify-content-sm-end">
                <input
                  class="form-control form-control-sm rounded bright"
                  placeholder="Search"
                  v-model="searchtext"
                  type="text"
                  v-on:keyup.enter="filterData()"
                />
                <div class="input-group-append">
                  <button
                    class="btn btn-link btn-sm"
                    type="button"
                    v-on:click="filterData()"
                  >
                    <i class="fa fa-search"></i>
                  </button>
                  <button
                    class="btn btn-link btn-sm"
                    type="button"
                    v-on:click="clearFilterData"
                  >
                    <i class="fa fa-times"></i>
                  </button>
                </div>
                <select
                  class="form-control form-control-sm rounded bright"
                  v-model="filtro_estado"
                  @change="filterData()"
                >
                  <option value>Todos</option>
                  <option value="9">Anulado</option>
                  <option value="A">Abierto</option>
                  <option value="B">Cerrado</option>
                  <option value="C">Finalizado</option>
                  <option value="D">En Contenedor</option>
                  <option value="E">En Ruta</option>
                  <option value="F">Entregado</option>
                  <option value="G">Recepcionando</option>
                  <option value="H">Detallado</option>
                </select>
                <select
                  class="form-control form-control-sm rounded bright"
                  v-model="tipo"
                  @change="filterData()"
                >
                  <option value="">Traslados y Devoluciones</option>
                  <option value="TRASLADO">Traslados</option>
                  <option value="DEVOLUCION">Devoluciones</option>
                </select>
                <select
                  class="form-control form-control-sm rounded bright"
                  v-model="inconsistencia"
                  @change="filterData()"
                >
                  <option value="">Todos</option>
                  <option :value="false">No tuvo inconsistencia</option>
                  <option :value="true">Tuvo inconsistencia</option>
                </select>
              </div>
            </div>
          </div>

          <TarimaTableComponent :tarima="tarimas" />
        </div>
        <PaginationComponent
          :currentPage="currentPage"
          :data="tarimas"
          @pagechanged="filterData"
        />
      </div>
    </div>
  </div>
</template>

<script>
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import TarimaTableComponent from "@/components/inventario/tarimas/TarimaTableComponent";
import DynamicService from "@/services/commons/DynamicService";
import PaginationComponent from "@/components/utils/PaginationComponent";

export default {
  components: {
    TarimaTableComponent,
    UsuarioEnTablaComponent,
    PaginationComponent,
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filtro_estado: "",
      tarimas: "",
      tipo: "",
      inconsistencia: "",
    };
  },
  mounted() {
    let self = this;
    self.refreshTarimas();
  },
  methods: {
    refreshTarimas(params) {
      let self = this;
      DynamicService.fetch("wms", "tarima", {}).then((response) => {
        self.tarimas = response.data;
      });
    },
    filterData(page) {
      if (page) {
        this.currentPage = page;
      }
      DynamicService.fetch("wms", "tarima", {
        page: this.currentPage,
        "filter[search]": this.$data.searchtext,
        estado: this.filtro_estado,
        tipo: this.tipo,
        tuvo_inconsistencia: this.inconsistencia,
      })
        .then((response) => {
          this.tarimas = response.data;
        })
        .catch((error) => {
          this.data = "";
        });
    },
    clearFilterData() {
      this.filtro_estado = "";
      this.searchtext = "";
      this.$data.currentPage = 1;
      this.tipo = "";
      this.filterData();
    },
  },
};
</script>
